<div>
  <div class="modal-header">
    <h2 class="modal-title text-capitalize">{{ rfq.product_name }}</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <table class="table table-striped" *ngIf="rfq.variant_parent_id == 0">
      <thead>
        <tr>
          <th [translate]="'TITLES.VARIANT_NAME'">Variant Name</th>
          <th [translate]="'TITLES.VARIANT_TERMS_VALUES'">Term / Value</th>
          <th width="100"
            >&nbsp;
            <a
              class="btn btn-primary btn-sm btn-round"
              href="javascript:;"
              (click)="addVariant()"
              [translate]="'BUTTONS.ADD'"
            >
              <i class="fas fa-plus"></i> Add
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let variant of variants; let i = index">
          <td class="text-capitalize">
            {{ variant.variant_name }}
          </td>
          <td>
            {{ variant.variant_terms.join(', ') }}
          </td>
          <td class="actions text-center">
            <a
              href="javascript:;"
              (click)="addVariant(variant, i)"
              class="text-brand"
              title="Edit"
            >
              <i class="fas fa-edit fa-fw"></i>
            </a>
            <a
              href="javascript:;"
              (click)="variants.splice(i, 1)"
              class="text-danger"
              title="Remove"
            >
              <i class="fas fa-trash fa-fw"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table table-striped" *ngIf="rfq.variant_parent_id > 0">
      <thead>
        <tr>
          <th [translate]="'TITLES.VARIANT_NAME'">Variant Name</th>
          <th [translate]="'TITLES.VARIANT_TERMS_VALUES'">Terms / Values</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let variant of variants; let i = index">
          <td class="text-capitalize">
            {{ variant.variant_name }}
          </td>
          <td>
            <select
              class="form-control"
              [(ngModel)]="selectedVariantTerms[variant.variant_name]"
            >
              <option value=""></option>
              <option [value]="term" *ngFor="let term of variant.variant_terms">{{
                term
              }}</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="button"
      (click)="updateRfqVariants()"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-success btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.UPDATE_VARIANTS'"
    >
      <i class="fas fa-save"></i> UPDATE_VARIANTS
    </button>
  </div>
</div>
